export const PERSONAL_CODE_LENGTH = 11
export const PERSONAL_CODE_REGEX = /^\d+$/

export const PHONE_LENGTH = 11
export const PHONE_REGEX = /^(\+\d+|\d+)$/
